<div class="dropdown dropdown-center">
    <a
    (click)="emitEvent('cell')"
    class="btn btn-outline-light btn-sm "
     role="button" data-bs-toggle="dropdown" aria-expanded="false">
     <i class="fa fa-ellipsis-v" aria-hidden="true" style="font-size: 15px;
     padding-inline: 5px;color: #212529;"></i>
    </a>
        <i class="fa fa-file position-relative"
        (click)="emitEvent('projectsList')"
        aria-hidden="true" style="margin-left: 5px; font-size: 16px; cursor: pointer;"
     ></i>
     <ng-container *ngIf="project['documents_count']">
      <span class="position-absolute start-100 translate-middle badge rounded-pill bg-danger"
      style="top: 10px;">
        {{project['documents_count']?project['documents_count']:0}}
      </span>
     </ng-container>
    <ul  class="dropdown-menu" style="cursor: pointer; overflow-y: auto; height: max-content; right: 40px;">
      <li
      *ngIf ="roles.edit_project"
      ><a class="dropdown-item" data-bs-toggle="modal"
        data-bs-target="#newProject"
        (click)="emitEvent('editProject')">
        <i class="fa fa-pencil" aria-hidden="true"></i>
        Edit Project</a></li>
      <li
      *ngIf ="roles.update_status"><a class="dropdown-item"
        (click)="emitEvent('editStatus')"
        data-bs-toggle="modal"
        data-bs-target="#statusUpdate">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        Update status</a></li>
        <li
        *ngIf ="!archiveMode && (roles.move_to_active)"
        ><a class="dropdown-item" (click)="emitEvent('archive')">
          <i class="fa fa-arrows" aria-hidden="true"></i>
         Move to Inactive</a></li>
         <li *ngIf ="archiveMode && (roles.move_to_active)"><a class="dropdown-item" (click)="emitEvent('archive')">
          <i class="fa fa-exchange" aria-hidden="true"></i>
         Move to Active</a></li>
         <li
         *ngIf ="roles.details_screen"
         ><a class="dropdown-item" (click)="emitEvent('product-details')">
          <i class="fa fa-list" aria-hidden="true"></i>
         Details</a></li>
         <li
         *ngIf ="roles.task_screen"
         ><a class="dropdown-item" (click)="emitEvent('tasks')">
          <i class="fa fa-tasks" aria-hidden="true"></i>
         Tasks</a></li>  <li
         *ngIf ="roles.conversation_screen"
         ><a class="dropdown-item" (click)="emitEvent('conversations')">
          <i class="fa fa-commenting-o" aria-hidden="true"></i>
         Conversation</a></li>
         <li
         *ngIf ="roles.conversation_screen"
         ><a class="dropdown-item" (click)="emitEvent('proposals')">
          <i class="fa fa-credit-card" aria-hidden="true"></i>
         Proposals</a></li>
         <li
         *ngIf ="roles.deal_team_screen"
         ><a class="dropdown-item" (click)="emitEvent('deal_team')">
          <i class="fa fa-credit-card" aria-hidden="true"></i>
         Team</a></li>
         <li
         *ngIf ="roles.delete_project"><a class="dropdown-item" (click)="emitEvent('delete')">
          <i class="fa fa-trash" aria-hidden="true"></i>
         Delete</a></li>
      <!-- <li *ngIf ="actions.detailsBtn"><a class="dropdown-item" (click)="emitEvent('product-details')">
        <i class="fa fa-list" aria-hidden="true"></i>
       Details</a></li>
       <li *ngIf ="actions.deleteProject"><a class="dropdown-item" (click)="emitEvent('delete')">
        <i class="fa fa-trash" aria-hidden="true"></i>
       Delete</a></li> -->
    </ul>
  </div>
